import styled from "styled-components";
import { Button, Grid } from "@material-ui/core";

export const STFieldWrapper = styled.div`
  {
    padding-bottom: 1rem;
  }
`;

export const STButton = styled(Button)`
  && {
    margin-top: 25px;
  }
`;

export const STButtonGrid = styled(Grid)`
  && {
    display: flex;
    justify-content: center;
  }
`;
